import { WhitelionIcon, WhitelionWhite } from "../../assets/svg";

function Navbar() {
  const isWhiteColor = false;

  return (
    <nav
      id="navbar-main"
      className={`${
        isWhiteColor ? "bg-custom-bg-white" : "bg-[#000000]"
      } mt-[0px] h-[80px] lg:h-[80px] sticky top-0 z-50 transition-all duration-100 lg:px-[160px] relative`}
    >
      <div className="flex flex-wrap items-center justify-between mx-auto lg:p-0 ">
        <a href="/" className="pl-4" aria-label="Whitelion homepage">
          {isWhiteColor ? <WhitelionIcon /> : <WhitelionWhite />}
        </a>

        <div className="pr-4">
          <div className="hidden lg:flex rounded-lg bg-[linear-gradient(145.42deg,_#00F0FF_-19.1%,_#0066FF_105.1%)] hover:cursor-pointer">
            <a
              href="https://web.airhome.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="block py-2 px-4 text-white rounded-lg hover:text-white"
            >
              Login
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
